import { Controller } from "@hotwired/stimulus"
import { NavigationHelper } from "~/helpers/navigation_helper"
import { DateHelper } from "~/helpers/date_helper"
import { CssHelper } from "~/helpers/css_helper"
import { Chart, registerables } from "chart.js"

Chart.register(...registerables)

export default class extends Controller {
  static targets = ["crawlChart", "crawlChartContainer"]

  connect() {
    // in case the user is on a Turbo preview of the page,
    // don't fetch the preview
    if (NavigationHelper.pageIsPreview()) { return }

    this.loadChart()
  }

  loadChart() {
    let _this = this
    fetch("/our-data/chart", { credentials: "same-origin" })
      .then(response => response.text())
      .then(html => {
        _this.crawlChartContainerTarget.innerHTML = html
        _this.drawChart()
      })
  }

  drawChart() {
    if (this.hasCrawlChartTarget === false) {
      return
    }

    let chartEl = this.crawlChartTarget.getContext("2d")
    let statHatData = JSON.parse(this.crawlChartTarget.dataset.volumeSeries)[0].points
    let chartData = []
    let chartLabels = []

    statHatData.forEach(function (point) {
      let date = new Date(point.time * 1000)

      chartData.push({
        x: date,
        y: parseInt(point.value),
      })

      chartLabels.push(DateHelper.fullMonthDate(date))
    })

    let chartMaxValue = Math.max(...chartData.map(value => value.y))

    let config = {
      type: "bar",
      data: {
        labels: chartLabels,
        datasets: [{
          data: chartData,
          backgroundColor: CssHelper.getVar("--colors-grey-800")
        }]
      },
      options: {
        responsive: true,
        aspectRatio: 5,
        layout: {
          padding: {
            top: 60
          }
        },
        scales: {
          x: {
            display: false
          },
          y: {
            display: false,
            min: 0,
            max: chartMaxValue
          },
        },
        plugins: {
          legend: {
            display: false
          },
          tooltip: {
            callbacks: {
              label: function (tooltipItem) {
                return `${App.numberWithCommas(tooltipItem.raw.y)} pages crawled`
              }
            },
            yAlign: "bottom",
            displayColors: false,
            padding: 12,
            titleFont: {
              family: CssHelper.getVar("--fonts-family-body"),
              size: 13
            },
            titleMarginBottom: 8,
            bodyFont: {
              family: CssHelper.getVar("--fonts-family-body"),
              size: 13
            },
            cornerRadius: 4,
            backgroundColor: CssHelper.getVar("--colors-grey-100"),
            titleColor: CssHelper.getVar("--colors-grey-900"),
            bodyColor: CssHelper.getVar("--colors-grey-700")
          }
        }
      }
    }

    new Chart(chartEl, config)
  }
}

